import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import PropTypes from "prop-types"; // <-- Add this import
import { useTranslation } from "react-i18next";

const AddCompetencyLevelDialog = ({
  open,
  onClose,
  handleSubmit,
  level,
  levelNames,
  competencyId,
}) => {
  const { t } = useTranslation();
  const [selectedName, setSelectedName] = useState("");
  const [selectedDefinition, setSelectedDefinition] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedCompId, setSelectedCompId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const getTodayDateString = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // 'YYYY-MM-DD'
  };

  useEffect(() => {
    if (open) {
      setSelectedName(""); // Load existing level if provided
      setSelectedDefinition("");
      setSelectedValue("");
      // setSelectedStartDate("");
      setSelectedStartDate(new Date().toISOString());
      setSelectedEndDate("");
      setSelectedCompId(competencyId);
      setErrors({}); // Reset errors on dialog open
    }
  }, [open, level]);

  const validate = () => {
    let newErrors = {};
    // if (!compName.trim()) newErrors.compName = " Competency Name is Required";
    if (!selectedName.trim()) {
      newErrors.selectedName = t("admin.competency.levelDialog.levelNameRequired");
    }
    if (selectedValue === null || selectedValue === "" || isNaN(Number(selectedValue))) {
      newErrors.selectedValue = t("admin.competency.levelDialog.valueMustBeNumerical");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    setLoading(true);
    const levelData = {
      levelName: selectedName,
      definition: selectedDefinition,
      value: selectedValue,
      competencyId: selectedCompId,
      startDate: selectedStartDate,
      endDate: null,
      // project_manager_name: projectManager,
    };
    await handleSubmit(levelData);
    setLoading(false);
    handleClose();
  };

  const handleClose = () => {
    setSelectedName(""); // Load existing level if provided
    setSelectedDefinition("");
    setSelectedValue("");
    setSelectedStartDate("");
    setSelectedEndDate("");
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("admin.competency.levelDialog.addCompetencyLevel")}</DialogTitle>
      <DialogContent>
        <TextField
          label={t("admin.competency.levelDialog.name") + " *"}
          value={selectedName}
          onChange={(e) => setSelectedName(e.target.value)}
          fullWidth
          margin="normal"
          error={!!errors.selectedName}
          helperText={errors.selectedName}
          sx={{
            "& .MuiInputBase-root": {
              height: "35px", // Adjust this value for the height you want
            },
          }}
        ></TextField>

        <TextField
          label={t("admin.competency.levelDialog.value") + " *"}
          type="number"
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
          error={!!errors.selectedValue}
          helperText={errors.selectedValue}
          fullWidth
          margin="normal"
          sx={{
            "& .MuiInputBase-root": {
              height: "35px", // Adjust this value for the height you want
            },
          }}
        ></TextField>

        <TextField
          label={t("admin.competency.levelDialog.definition")}
          value={selectedDefinition}
          onChange={(e) => setSelectedDefinition(e.target.value)}
          fullWidth
          margin="normal"
          sx={{
            "& .MuiInputBase-root": {
              height: "35px", // Adjust this value for the height you want
            },
          }}
        ></TextField>
      </DialogContent>
      {!loading ? (
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            {t("admin.competency.levelDialog.cancel")}
          </Button>

          <Button
            onClick={handleSave}
            color="primary"
            sx={{
              "&:hover": { backgroundColor: "blue", color: "#fff" },
            }}
          >
            {t("admin.competency.levelDialog.save")}
          </Button>
        </DialogActions>
      ) : (
        <Box display="flex" justifyContent="flex-end" p={1}>
          <CircularProgress size={20} sx={{ color: "black" }} />
        </Box>
      )}
    </Dialog>
  );
};

AddCompetencyLevelDialog.propTypes = {
  open: PropTypes.bool.isRequired, // `open` should be a required boolean
  onClose: PropTypes.func.isRequired, // `onClose` should be a required function
  handleSubmit: PropTypes.func.isRequired, // `handleSubmit` should be a required function
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  levelNames: PropTypes.array.isRequired,
  competencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // ✅ Add this line
};

export default AddCompetencyLevelDialog;
